import CryptoJS from 'crypto-js'

export default {
    //加密
    encrypt(data){
        const key  = CryptoJS.enc.Utf8.parse('o08YQii9QF5MuzYj');
        let res = CryptoJS.DES.encrypt(JSON.stringify(data), key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).ciphertext.toString();
        return res;
    },

    //解密
    decrypt(data){
        const key  = CryptoJS.enc.Utf8.parse('o08YQii9QF5MuzYj');
        let res = CryptoJS.DES.decrypt({
            ciphertext: CryptoJS.enc.Hex.parse(data)
        }, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        })
        return CryptoJS.enc.Utf8.stringify(res);
    }

}

